import React, { useState, useRef, useEffect } from "react";
// import "./dropdown.css";
// import DropDownIcon from "../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  useEffect(() => {
    if (selected === "") {
      setSelectedLabel(placeholder); // Reset to placeholder if cleared
    } else {
      const selectedOption = options.find((option) => option.id === selected);
      setSelectedLabel(selectedOption ? selectedOption.label : placeholder);
    }
  }, [selected, options, placeholder]);
  
  return (
    <div className="dropdown" style={{ width, marginLeft, marginTop}} ref={dropdownRef}>
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={() => setIsActive(!isActive)}>
        {/* {selectedLabel} */}
        {selectedLabel || placeholder}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}




















{/* <div className="selecte-dropdown-items">
                <label>Gender</label>
                <select
                  name="gender_id"
                  value={values.gender_id}
                  onChange={onChange}
                >
                  {genderdata &&
                    genderdata.map((gender) => (
                      <option key={gender.gender_id} value={gender.gender_id}>
                        {gender.gender_name}
                      </option>
                    ))}
                </select>
              </div> */}